import React from "react";
import Header from "../components/landing/Header";
import HeroSection from "../components/landing/HeroSection";
import CTASection from "../components/landing/CTASection";
import MiddleSection from "../components/landing/MiddleSection";
import EmailGrabber from "../components/landing/EmailGrabber";
import BottomSection from "../components/landing/BottomSection";
import Footer from "../components/landing/Footer";

export default function LandingPage() {
	const handleEmailSubmit = (email) => {
		alert(`Thank you! We'll notify you at: ${email}`);
	};

	return (
		<main className="flex flex-col w-full bg-zinc-50">
			<div className="flex flex-col flex-1 w-full">
				<div className="flex flex-col justify-strech min-h-screen">
					<Header />	
					<HeroSection />
					<CTASection />
					<MiddleSection />
				</div>
				<EmailGrabber onEmailSubmit={handleEmailSubmit} />
				<BottomSection />
			</div>
			<Footer />
		</main>
	);
}
